import React, { useState, useEffect } from 'react';
import api from './../../utils/api';
import { Button } from 'react-bootstrap';
import { numberFormat } from './../../utils/functions';
import { toast } from 'react-toastify';
import moment from "moment";
import 'moment/locale/th'
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import Lightbox from 'react-image-lightbox';

export default function BookingImageOverviewWithPrice({ code }) {
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const [data, setData] = useState({})
  const [downloading, setDownloading] = useState(false)

  const [imageUrl, setImageUrl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const { hotel, monthAndYearDisplay, monthAndYear, dayOfMonth, rooms, bookingItems, roomBlockDays, walkinBookingItems, walkinBlockDays, isWalkin } = data;

  const fetchData = () => {
    api.request('bookings/get-booking-overview-data', (data) => {
      if (data?.is_success) {
        setData(data);
      } else {
        setData({});
      }
    }, {
      date: moment(currentMonth).format('YYYY-MM-DD'),
      code: code,
    })
  }

  const fetchImage = () => {
    if (downloading) {
      return;
    }

    setDownloading(true)
    api.request('bookings/get-booking-overview-image', (data) => {
      setDownloading(false)
      if (data?.is_success) {
        setImageUrl(data.image);
        setIsOpen(true);
      } else {
        toast.error("ไม่สามารถดาวน์โหลดรูปภาพได้");
      }
    }, {
      date: moment(currentMonth).format('YYYY-MM-DD'),
      code: code,
    });
  };

  useEffect(() => {
    if (!currentMonth) {
      return;
    }
    fetchData()
  }, [currentMonth])

  useEffect(() => {
    if (!code) {
      return;
    }
    fetchData()
  }, [code])

  const sumBookingNetTotal = (room_id) => {
    const roomBookings = bookingItems.filter(item => item.room_id === room_id && !item.is_close_zone) || []
    return _.sum(roomBookings.map(item => Number(item.net_total) || 0));
  }

  const sumBookingPaidAmount = (room_id) => {
    const roomBookings = bookingItems.filter(item => item.room_id === room_id && !item.is_close_zone) || []
    return _.sum(roomBookings.map(item => Number(item.paid_amount) || 0));
  }

  const sumBookingBalanceAmount = (room_id) => {
    const roomBookings = bookingItems.filter(item => item.room_id === room_id && !item.is_close_zone) || []
    return _.sum(roomBookings.map(item => {
      return Number(item.net_total || 0) - Number(item.paid_amount || 0);
    }));
  }

  const walkingBookingsNetTotal = isWalkin ? _.sum((walkinBookingItems.filter(x => !x.is_close_zone) || []).map(item => Number(item.net_total) || 0)) : 0;
  const walkingBookingsPaidAmount = isWalkin ? _.sum((walkinBookingItems.filter(x => !x.is_close_zone) || []).map(item => Number(item.paid_amount) || 0)) : 0;
  const walkingBookingsBalanceAmount = isWalkin ? _.sum((walkinBookingItems.filter(x => !x.is_close_zone) || []).map(item => {
    return Number(item.net_total || 0) - Number(item.paid_amount || 0);
  })) : 0;

  const closeZoneBookingsNetTotal = _.sum(
    _(bookingItems)
      .filter(x => x.is_close_zone)
      .uniqBy(x => x.main_id)
      .map(item => Number(item.net_total) || 0)
      .value()
  );

  const sumBookingAndBlockdaysCount = (room_id) => {
    const roomBookings = bookingItems.filter(item => item.room_id === room_id) || []

    const bookingDays = roomBookings.reduce((acc, item) => {
      const startDate = moment(item.start_date);
      const endDate = moment(item.end_date);
      const days = [];
      for (let m = startDate; m.isSameOrBefore(endDate); m.add(1, 'days')) {
        if (moment(m).isSame(currentMonth, 'month')) {
          days.push(m.format("YYYY-MM-DD"));
        }
      }
      return acc.concat(days);
    }, []);

    const roomBlockDaysLength = roomBlockDays.filter(item => item.room_id === room_id && !bookingDays.includes(moment(item.date).format('YYYY-MM-DD')))?.length || 0;
    return bookingDays.length + roomBlockDaysLength;
  }

  const walkingBookingsLength = isWalkin ? walkinBookingItems?.length || 0 : 0;
  const walkinGuestSummary = isWalkin ? _.sumBy((walkinBookingItems || []), (item) => {
    return item.is_close_zone ? 0 : Number(item.guest_summary || 0);
  }) : 0;

  return (
    <>
      {!data?.is_success && <div style={{ minHeight: 800 }}></div>}
      {data?.is_success && <div className="text-center p-2 booking-image-overview-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h3>Booking Overview</h3>
        <h3>{hotel.name_th}</h3>
        <div className="d-flex mb-3 align-items-center">
          <div className="overview-state-info" style={{ backgroundColor: '#90ee9061' }}></div><span className="text-black ms-2">Booked</span>
          <div className="overview-state-info ms-3" style={{ backgroundColor: '#ff00005e' }}></div><span className="text-black ms-2">Blocked</span>
          <div className="text-black text-end" style={{ flex: 1 }}>
            <div>Exported by ONCE IN MEMORY</div>
            <div>{`Latest update: ${moment().locale('th').format('DD/MM/YYYY HH:mm ')}`}</div>
          </div>
        </div>

        <div className="d-flex align-items-center mb-2">
          <Button
            variant="outline-success"
            className="btn btn-sm "
            onClick={() => setCurrentMonth(prev => moment(prev).subtract(1, 'months').toDate())}
          >
            &lt; Prev
          </Button>
          <h4 className="mb-0 px-3">{monthAndYearDisplay}</h4>
          <Button
            variant="outline-success"
            className="btn btn-sm "
            onClick={() => setCurrentMonth(prev => moment(prev).add(1, 'months').toDate())}
          >
            Next &gt;
          </Button>
          {/* <div style={{ flex: 1 }} className="text-end d-none d-md-block">
            <Button
              variant="outline-danger"
              className="btn btn-sm "
              onClick={() => fetchImage()}
              disabled={downloading}
            >
              <i className="fal fa-download"></i> {downloading ? 'Downloading...' : 'Download Image'}
            </Button>
          </div> */}
        </div>
        {/* <div className="text-start d-block d-md-none">
          <Button
            variant="outline-danger"
            className="btn btn-sm "
            onClick={() => fetchImage()}
            disabled={downloading}
          >
            <i className="fal fa-download"></i> {downloading ? 'Downloading...' : 'Download Image'}
          </Button>
        </div> */}
        {isOpen && imageUrl && (
          <Lightbox
            mainSrc={imageUrl}
            onCloseRequest={() => {
              setIsOpen(false);
              setImageUrl(null);
            }}
            imageTitle="แตะค้าง/คลิกขวาที่รูปเพื่อบันทึกลงเครื่อง"
            enableZoom={false}
            discourageDownloads={false}
            clickOutsideToClose={false}
          />
        )}
        <div className="booking-image-overview-table" style={{ overflowX: 'auto' }}>
          <table className="table table-bordered" style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#d3d3d37d' }}>
            <thead>
              <tr>
                <th style={{ width: '40px' }}>DAY</th>
                <th style={{ width: '40px' }}>DATE</th>
                {rooms.map((room, index) => {
                  return <th key={index} >{room.name_th}</th>
                })}

                {!!isWalkin && <th>CAMPING</th>}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: dayOfMonth }, (_, i) => i + 1).map((day, index) => {
                const currentdate = moment(`${monthAndYear}-${day < 10 ? `0${day}` : day}`).format("YYYY-MM-DD")
                const dayOfWeek = moment(currentdate).day()
                // const color = getColorFromDay(dayOfWeek);
                const dayName = moment(currentdate).locale('en').format('ddd')

                const walkinBookingItem = walkinBookingItems.find((b) => b.date === currentdate)
                const walkinBlockDay = walkinBlockDays.find((b) => b.date === currentdate)
                return <tr key={index}>
                  <td >{dayName}</td>
                  <td >
                    <div className="d-flex justify-content-center align-items-center">
                      <span>{day < 10 ? `0${day}` : day}</span>
                    </div>
                  </td>
                  {rooms.map((room, index) => {
                    const bookingItem = bookingItems.find((b) => b.room_id === room.id && b.start_date <= currentdate && b.end_date >= currentdate)
                    const roomBlockDay = roomBlockDays.find((b) => b.room_id === room.id && b.date === currentdate)

                    const bookingBgCls = !!bookingItem ?
                      (bookingItem.is_close_zone ? 'booking-overview-closeall' : (Number(bookingItem.day_qty) > 1 ? 'booking-overview-multiple' : 'booking-overview-normal')) : (!!roomBlockDay ? 'booking-overview-blocked' : '');

                    const infoStr = bookingItem ? `${numberFormat(bookingItem.net_total, true)}` : (roomBlockDay ? 'X' : '');
                    return <td className={`${!!bookingItem ? 'text-end' : 'text-center'} ${bookingBgCls}`} key={index}>
                      <div>
                        {bookingItem?.is_close_zone && <i className="fal fa-info-circle me-1 text-white"></i>}
                        {!bookingItem?.is_close_zone && (Number(bookingItem?.day_qty) > 1) && <span>{bookingItem?.day_qty}<i className="fal fa-calendar-alt mx-1"></i></span>}
                        <span className={`${bookingItem?.is_close_zone ? 'text-white' : ''}`}>{infoStr}</span>
                      </div>
                      {!!bookingItem && <div className="customer-info">
                        <small className={`d-block ${bookingItem?.is_close_zone ? 'text-white' : 'text-muted'}`}>{bookingItem?.contact_name}</small>
                        <small className={`d-block ${bookingItem?.is_close_zone ? 'text-white' : 'text-muted'}`}>{bookingItem?.contact_tel_1}</small>
                      </div>}
                    </td>
                  })}
                  {!!isWalkin && <td style={{ backgroundColor: !!walkinBookingItem ? '#90ee9061' : (!!walkinBlockDay ? '#ff00005e' : '') }}>
                    {!!walkinBookingItem ? (walkinBookingItem.is_close_zone ? '-' : Number(walkinBookingItem?.net_total || 0)) : (!!walkinBlockDay ? 'X' : '')}
                  </td>}
                </tr>
              })}
              <tr>
                <td colSpan={2}></td>
                {rooms.map((room, index) => {
                  return <td key={index} >{room.name_th}</td>
                })}
                {!!isWalkin && <td>CAMPING</td>}
              </tr>
              <tr className="table-summary">
                <td colSpan={2} className="date-td"><small style={{ fontWeight: 500 }}>ชำระแล้ว/ยอดค้าง</small></td>
                {rooms.map((room, index) => {
                  const paidAmount = sumBookingPaidAmount(room.id);
                  const balanceAmount = sumBookingBalanceAmount(room.id);
                  return <td className="sum-font-regular" key={index} >
                    <span className="me-1 text-success">{numberFormat(paidAmount, true)}</span>/
                    <span className="ms-1 text-danger">{numberFormat(balanceAmount, true)}</span>
                  </td>
                })}
                {!!isWalkin && <td className="sum-font-regular">
                  {/* จำนวนวันที่มี booking ไม่ใช่จำนวน booking */}
                  <span className="me-1 text-success">{numberFormat(walkingBookingsPaidAmount, true)}</span>/
                  <span className="ms-1 text-danger">{numberFormat(walkingBookingsBalanceAmount || 0, true)}</span>
                </td>}
              </tr>
              <tr className="table-summary">
                <td colSpan={2} className="date-td">จำนวน/รายได้</td>
                {rooms.map((room, index) => {
                  const totalCount = sumBookingAndBlockdaysCount(room.id);
                  const netTotal = sumBookingNetTotal(room.id);
                  return <td className="booking-sum-td " key={index} >
                    <span><i className="fal fa-calendar"></i> {numberFormat(totalCount, true)}</span>
                    <span className="ms-2"><i className="fal fa-comment-dollar"></i> {numberFormat(netTotal, true)}</span>
                  </td>
                })}
                {!!isWalkin && <td className="booking-sum-td ">
                  {/* จำนวนวันที่มี booking ไม่ใช่จำนวน booking */}
                  <span><i className="fal fa-calendar"></i> {numberFormat(walkingBookingsLength, true)}</span>
                  <span className="ms-2"><i className="fas fa-users"></i> {numberFormat(walkinGuestSummary || 0, true)}</span>
                  <span className="ms-2"><i className="fal fa-comment-dollar"></i> {numberFormat(walkingBookingsNetTotal || 0, true)}</span>
                </td>}
              </tr>
              <tr className="table-summary">
                <td colSpan={2} className="date-td">OCC Rate</td>
                {rooms.map((room, index) => {
                  const totalCount = sumBookingAndBlockdaysCount(room.id);
                  const occ = totalCount > 0 ? (Number(totalCount) / Number(dayOfMonth)) * 100 : 0;

                  return <td key={index} >
                    <span className={`me-1 text-${occ < 50 ? 'danger' : 'success'}`}>{numberFormat(occ, true)}%</span>
                  </td>
                })}
                {!!isWalkin && <td className="sum-font-regular">
                  -
                </td>}
              </tr>
            </tbody>
          </table>
          {closeZoneBookingsNetTotal > 0 && <div className="text-start">
            <p className="text-success">รายได้เหมาทุกห้อง : {numberFormat(closeZoneBookingsNetTotal, true)} บาท <span className="ms-2 text-black">***กรณีลูกค้าเหมาทุกห้อง รายได้จะไม่ได้รวมอยู่ท้ายตาราง</span></p>
          </div>}
        </div>
      </div>}
    </>
  );
}
